import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";

const MySwal = withReactContent(Swal2);

const AddStatus = (props) => {
  const [loading, setLoading] = useState(true);
  const [leads, setLeads] = useState([]);
  const [name, setName] = useState(
    props.mode === "edit" ? props.statusEdit.name : ""
  );
  const [color, setColor] = useState(
    props.mode === "edit" ? props.statusEdit.color : ""
  );
  const [poz, setPoz] = useState(
    props.mode === "edit" ? props.statusEdit.poz : ""
  );
  const [edit, setEdit] = useState(props.mode === "edit" ? false : true);

  const fetchLeads = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getLeadsAssDataStatus", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLeads(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchLeads();
  };

  useEffect(() => {
    getData();
  }, []);

  const validate = () => {
    if (!name || !color) {
      return false;
    } else {
      return true;
    }
  };

  const fetchAddStatus = async () => {
    var body = {
      name: name,
      color: color,
      poz: poz,
    };

    await fetch("https://apisplit.ftpeople.pl/addStatus", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Status",
          text: "dodany",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const addStatus = () => {
    if (validate()) {
      fetchAddStatus();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
    }
  };

  const fetchEditStatus = async () => {
    var body = {
      id: props.statusEdit.id,
      name: name,
      color: color,
      poz: poz,
    };

    await fetch("https://apisplit.ftpeople.pl/editStatus", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Status",
          text: "zmieniony",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const editStatus = () => {
    if (validate()) {
      fetchEditStatus();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
    }
  };

  //check
  const fetchDeleteStatus = async (newUser) => {
    var body = { id: props.userEdit.id, newUser: newUser };

    await fetch("https://apisplit.ftpeople.pl/deleteStatus", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Status",
          text: "usunięty",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const deleteStatus = (e) => {
    var check = leads.filter((el) => el.status === e.target.value).length;
    if (check === 0) {
      fetchDeleteStatus();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Nie można usunąć statusy",
        text: "przypisano do niego leady",
      }).then(async (result) => {
        getData();
      });
    }
  };

  const endEditMode = (e) => {
    setEdit(false);
    setName(props.statusEdit.name);
    setColor(props.stautsEdit.color);
  };

  return (
    <>
      <div
        style={{
          width: "50vw",
          borderRadius: "15px",
          boxShadow: "-8px 0px 24px 0px rgba(66, 68, 90, 1)",
          position: "fixed",
          right: "0",
          top: "10vh",
          backgroundColor: "white",
          padding: "2%",
          margin: "0px 10px",
        }}
      >
        {loading ? (
          <Loading />
        ) : (
          <>
            <div style={{ display: "flex", marginBottom: "3vh" }}>
              <div
                style={{
                  width: "85%",
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "2vw",
                }}
              >
                {edit
                  ? props.mode === "edit"
                    ? "EDYTUJ STATUS"
                    : "DODAJ STATUS"
                  : "STATUS"}
                <br />
              </div>
              <div style={{ width: "15%" }}>
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "navy",
                    borderColor: "navy",
                    width: "100%",
                  }}
                  onClick={props.close}
                >
                  X
                </button>
              </div>
            </div>
            <div style={{ display: "flex", gap: "50px" }}>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  nazwa <span style={{ color: "red" }}>*</span>
                </p>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  disabled={!edit}
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
              </div>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  color <span style={{ color: "red" }}>*</span>
                </p>
                <input
                  type="color"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  disabled={!edit}
                  value={color}
                  onChange={(e) => {
                    setColor(e.target.value);
                  }}
                />
              </div>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  pozycja <span style={{ color: "red" }}>*</span>
                </p>
                <input
                  type="number"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  disabled={!edit}
                  value={poz}
                  onChange={(e) => {
                    setPoz(e.target.value);
                  }}
                />
              </div>
            </div>

            <div
              style={{
                marginTop: "50px",
                display: "flex",
                gap: "20px",
              }}
            >
              {edit ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "green",
                      borderColor: "green",
                    }}
                    onClick={props.mode === "edit" ? editStatus : addStatus}
                  >
                    {props.mode === "edit" ? "EDYTUJ" : "DODAJ"} STATUS
                  </button>
                </>
              ) : (
                ""
              )}
              {props.mode === "edit" && !edit ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "navy",
                      borderColor: "navy",
                    }}
                    onClick={() => setEdit(true)}
                  >
                    TRYB EDYCJI
                  </button>
                </>
              ) : (
                ""
              )}

              {props.mode === "edit" && edit ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "red",
                      borderColor: "red",
                    }}
                    onClick={endEditMode}
                  >
                    ZAKOŃCZ TRYB EDYCJI
                  </button>
                </>
              ) : (
                ""
              )}

              {props.mode === "edit" ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "red",
                      borderColor: "red",
                    }}
                    onClick={deleteStatus}
                  >
                    USUŃ
                  </button>
                </>
              ) : (
                ""
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddStatus;
